import { Injectable } from '@angular/core';
import { ApiService } from './../../services/api';
import { environment } from '../../../environments/environment';
import { AngularFireDatabase } from 'angularfire2/database';

@Injectable()
export class VersionCheckService {
  // this will be replaced by actual hash post-build.js
  private currentHash = environment.version;

  constructor(private apiService: ApiService, private firebase: AngularFireDatabase) { }

  /**
   * Checks in every set frequency the version of frontend application
   * @param url
   * @param {number} frequency - in milliseconds, defaults to 30 minutes
   */
  public initVersionCheck(url, frequency = 120000) {
    console.log(url)
    if (environment.production)
      this.checkVersion(url);

  }

  /**
   * Will do the call and check if the hash has changed or not
   * @param url
   */
  private checkVersion(url) {
    // timestamp these requests to invalidate caches
    this.firebase.object("currentVersion/3")
      // .first()
      .subscribe(
        (response: any) => {
          // console.log(response)
          const hash = response.version;
          const hashChanged = this.hasHashChanged(this.currentHash, hash);

          // If new version, do something
          if (hashChanged) {
            // ENTER YOUR CODE TO DO SOMETHING UPON VERSION CHANGE
            // for an example: location.reload();
            // location.reload();
          }
          // store the new hash so we wouldn't trigger versionChange again
          // only necessary in case you did not force refresh
          this.currentHash = hash;
        },
        (err) => {
          console.error(err, 'Could not get version');
        }
      );
  }

  /**
   * Checks if hash has changed.
   * This file has the JS hash, if it is a different one than in the version.json
   * we are dealing with version change
   * @param currentHash
   * @param newHash
   * @returns {boolean}
   */
  private hasHashChanged(currentHash, newHash) {
    console.log(currentHash, newHash)


    return currentHash !== newHash;
  }
}
